import React, { useEffect } from "react";
import { Route, Routes } from "react-router-dom";
import ApprovalChainList from "./List";
import ApprovalChainEditor from "./Editor";

export default function ApprovalChains() {
  useEffect(() => { document.title = "Approval chains - Ample Hire"; }, []);
  return (
    <Routes>
      <Route index element={<ApprovalChainList />} />
      <Route path="new" element={<ApprovalChainEditor mode="new" />} />
      <Route path=":id" element={<ApprovalChainEditor mode="edit" />} />
    </Routes>
  );
}
